<template>
  <div class="p-4">
    <div class="flex justify-end text-theme text-medium mb-4">
      结算调查员<span>{{ Number(info.investigatorNumAll) }}</span
      >人，到手金额 <span>{{ Number(info.totalYuanAmountAll).toFixed(2) }}</span
      >元，服务费 <span>{{ Number(info.rateAmountAll).toFixed(2) }}</span
      >元，结算总费用 <span>{{ Number(info.rateAfterAll).toFixed(2) }}</span
      >元
    </div>
    <data-table
      :data="tableData"
      :columns="tableColumn"
      :page="page"
      :showPage="true"
      :loading="loading"
      @size-change="sizeChange"
      @pagination-current-change="currentChange"
      ref="tableRef"
      :height="'calc(100vh - 164px - 30px)'"
    >
      <!-- 结算状态 -->
      <template #action="{ row }">
        <div style="text-align: center">
          <div
            :class="{
              'text-yellow-theme': row.action == 0
            }"
          >
            {{ actionMap[row.action] }}
          </div>
        </div>
      </template>
      <!-- 菜单 -->
      <template #opt="{ row }">
        <el-button v-if="row.action == 3" @click="toAudit(row)" type="text">去处理</el-button>
        <el-button v-else @click="toAudit(row)" type="text">查看</el-button>
      </template>
      <template #table-footer>
        <!-- 网站协议文案提示 -->
        <DygcFooter class="mt-2 -mb-2" />
      </template>
    </data-table>
  </div>
</template>

<script>
import { getApproveTask } from '@/api/wenjuan/commonSettlement'
import DataTable from '@/components/base/DataTable'
import { tableColumn } from './option'
import DygcFooter from 'components/dygc-footer-bottom/index'

export default {
  components: {
    DataTable,
    DygcFooter
  },
  data() {
    return {
      tableColumn,
      tableData: [],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 20,
        pageSizes: [10, 20, 30, 50, 100]
      },
      loading: false,
      actionMap: {
        '-1': '已驳回',
        0: '已拒绝',
        1: '已通过',
        2: '已提交',
        3: '待审核',
        null: '未开始'
      },
      actionColorMap: {
        '-1': 'text-333',
        0: 'text-yellow-theme',
        1: 'text-333',
        2: 'text-333',
        3: 'text-333',
        null: 'text-333'
      },
      info: {
        investigatorNumAll: 0,
        totalYuanAmountAll: 0,
        rateAmountAll: 0,
        rateAfterAll: 0
      }
    }
  },
  methods: {
    toAudit(row) {
      this.$router.push({
        name: 'approval-deal',
        query: {
          processInstanceId: row.processInstanceId,
          approvalType: 'settlement',
          fromPage: 'approval-deal'
        }
      })
    },
    // 获取列表
    getList() {
      this.loading = true
      let params = {
        currentPage: this.page.currentPage,
        pageSize: this.page.pageSize,
        approve: ''
      }
      getApproveTask(params)
        .then(res => {
          if (res.data.code != 0) {
            this.$message.error(res.data.msg)
            this.loading = false
            return
          }
          this.page.total = res.data.data.totalNum
          this.page.currentPage = res.data.data.currentPage
          this.page.pageSize = res.data.data.pageSize
          this.tableData = res.data.data.statementTasks
          this.info = res.data.data
          this.tableData.forEach(item => {
            item.totalYuanAmount = Number(item.totalYuanAmount).toFixed(2)
            item.rateAmount = Number(item.rateAmount).toFixed(2)
            item.rateAfter = Number(item.rateAfter).toFixed(2)
          })
          this.loading = false
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 点击 每页显示条数 触发
    sizeChange(val) {
      this.page.currentPage = 1
      this.page.pageSize = val
      this.getList()
    },
    // 切换页面 （点击页码、数字、输入数字） 触发
    currentChange(val) {
      this.page.currentPage = val
      this.getList()
    }
  },
  created() {
    this.getList()
  }
}
</script>

<style scoped lang="scss"></style>
